<template>
  <div class="data page">
    <main>
      <form @submit.prevent="nextStep">
        <div class="container-fluid">
          <div class="row pb-24">
            <div class="col-12 col-lg-6 offset-lg-3">

              <router-link :to="{ name: 'step1' }" class="previous-step">
                <span>Mijn gegevens</span>
                <span>Stap 1 van 3</span>
              </router-link>

              <router-link :to="{ name: 'step2' }" class="previous-step">
                <span>Mijn woonsituatie</span>
                <span>Stap 2 van 3</span>
              </router-link>

              <router-link :to="{ name: 'step3' }" class="previous-step">
                <span>Mijn inkomensgegevens</span>
                <span>Stap 3 van 3</span>
              </router-link>

              <div class="step">
                <div class="step__part  border-top-0">
                  <h3 class="h1">Samenvatting definitief inschrijven</h3>
                  <p>Uw {{ $favorites.length }} voorkeuren voor het project {{ projectName }}.</p>
                  <house-tile-status v-for="(object, i) in $favorites" :house="object" :key="i"/>
                  <button :disabled="loading" type="button" @click="$router.push({ name: 'preferences' })" class="btn btn-grey">Wijzig voorkeuren</button>
                </div>

                <div class="step__part">
                  <div class="form-row">
                    <div class="form-field form-field__radio">
                      <label class="form-field__radio--label">Voorkeur taal</label>
                      <div class="radio-field">
                        <input type="radio" v-model="data.preferred_language" value="nl" required id="Dutch" name="language">
                        <label for="Dutch">Nederlands</label>
                      </div>
                      <div class="radio-field">
                        <input type="radio" v-model="data.preferred_language" value="en" required id="English" name="language">
                        <label for="English">Engels</label>
                      </div>
                    </div>
                  </div>
                </div>

<!--                <div class="step__part">-->
<!--                  <div class="form-row">-->
<!--                    <div class="form-field form-field__radio">-->
<!--                      <label class="form-field__radio&#45;&#45;label">Nieuwsbrief?</label>-->
<!--                      <div class="radio-field">-->
<!--                        <input type="radio"  id="Yes" name="newsletter">-->
<!--                        <label for="Yes">Ja</label>-->
<!--                      </div>-->
<!--                      <div class="radio-field">-->
<!--                        <input type="radio" checked id="No" name="newsletter">-->
<!--                        <label for="No">Nee</label>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

                <div v-for="(target, i) in targets" :key="i" class="step__part">
                  <div class="form-row">
                    <div v-if="target.type === 'select'" class="form-field w-m-100 w-80">
                      <label class="">{{ target.label }}</label>
                      <p style="font-size: 12px;" v-if="target.hint">{{ target.hint }}</p>
                      <select :required="target.required" v-model="data.targets[target.name]" :name="target.name">
                        <option :value="null" selected disabled>Selecteer</option>
                        <option v-for="option in target.options" :key="option.value" :value="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                    <div v-if="target.type === 'checkbox'" class="form-field w-m-100 w-80 checkbox">
                      <label class="checkbox-label"><input type="checkbox" :value="data.targets[target.name]" v-model="data.targets[target.name]"> <p>{{ target.label }}</p></label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!--                        <div class="col-3 pt-24  d-none d-lg-block">-->
            <!--                            <div class="h-100 d-flex justify-content-end">-->
            <!--                                <div class="tooltip-wrap">-->
            <!--                                    <a class="tooltip-btn">Info</a>-->
            <!--                                    <div class="tooltip-content">-->
            <!--                                        Tooltip over twee regels.-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>

          <div class="row justify-content-center">
            <div class="col-12 col-lg-6">

              <div class="errors" v-if="errors">
                <p>Je hebt niet alle gegevens juist ingevuld. Ga terug en controlleer de volgende fouten:</p>
                <ul>
                  <li v-for="(error, i) in errors" :key="i">{{ error[0] }}</li>
                </ul>
              </div>


              <div class="step__footer d-flex justify-content-between">
                <button :disabled="loading" type="button" @click="$router.push({ name: 'step1' })" class="btn btn-grey btn-back icon-caret-left">Terug naar stap 1</button>
                <button :disabled="loading" class="btn btn-primary">{{ loading ? 'Bezig met versturen...' : 'Versturen' }}</button>
              </div>
            </div>
          </div>

        </div>
      </form>
    </main>
  </div>
</template>


<script>
  import HouseTile from '../components/HouseTile.vue'
  import HouseTileStatus from '../components/HouseTileStatus.vue'

  export default {
    components: {
      HouseTile,
      HouseTileStatus
    },
    data () {
      return {
        loading: false,
        data: {},
        targets: [],
        errors: null
      }
    },
    mounted(){
      if(Object.keys(this.$store.state.form).length > 0){
        this.data = this.$store.state.form
      } else {
        this.prefill()
      }
      const targets = this.$store.state.apiData.targets;
      targets.forEach(target => {
        if(! this.data.targets[target.name]) {
          this.data.targets[target.name] = null;
        }
      });
      this.targets = targets;
    },
    computed: {
      projectName(){
        return this.$store.state.apiData.project.name
      }
    },
    methods: {
      nextStep () {
        this.$store.commit('saveStep',this.data)
        this.submit().then(() => {
          this.$router.push({ name: 'bedankt'})
        }).catch(() => {
          //
        })
      },
      prefill () {
        if(!this.$user){
          return
        }
        let user = this.$user

        // set user data
        Object.entries(user).forEach((row) => {
          let name = row[0]
          let value = row[1]
          if(value && typeof value !== 'object'){
            if(!this.data[name]) {
              this.$set(this.data, name, value)
            }
          }
        })
      },
      submit () {
        this.errors = null
        this.loading = true
        return new Promise((resolve, reject) => {
          let url = this.$route.params.selector_id + '/submit'
          if(this.$user){
            url += '/' + this.$store.state.userToken
          }

          let favorites = []

          this.$favorites.forEach((object) => {
            favorites.push({
              id: object.id,
              not_assignable: false
            })
          })

          this.$notAssignable.forEach((object) => {
            favorites.forEach((obj, i) => {
              if(obj.id === object.id){
                favorites[i].not_assignable = true
              }
            })
          })

          let data = {
            form_data: this.$store.state.form,
            objects: favorites
          }
          console.log(data)
          this.axios.post(url, data).then(() => {
            resolve()
          }).catch((e) => {
            if(e.response && e.response.status && e.response.status === 400){
              this.errors = e.response.data.errors
            }
            reject()
          }).finally(() => {
            this.loading = false
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .errors {
    background-color: #cc3d41;
    color: #fff;
    padding: 15px;
    padding-bottom: 5px;
    border-radius: 5px;
    p {
      color: #fff;
    }
    ul {
      padding: 0;
      padding-left: 20px;
    }
  }
  .checkbox-label {
    font-weight: normal;
    font-size: 15px;
    p {
      float: right;
      color: #333;
      line-height: 18px;
      width: calc(100% - 35px);
    }
  }
  .checkbox input {
    margin-right: 5px;
    -webkit-appearance: none;
    border-radius: 3px;
    width: 24px;
    height: 24px;
    border: 1px solid #000;
    opacity: .3;
    position: relative;
    float: left;

    &:checked {
      opacity: 1;
      &:after {
        border-radius: 2px;
        content: '';
        display:block;
        width: 14px;
        height: 14px;
        background-color: #000;
        margin-left: 4px;
        margin-top: 4px;
      }
    }
  }
</style>
